// frontend/src/pages/partnerTemplates.js
// ✉️ Partner-levél sablonok.
//
// Három helyzetre, mert a partnerek nem egyformák, és ugyanaz a levél mindhárom
// csoportnak rosszul szól:
//   restart  — volt már regisztrációja, de elhallgatott
//   start    — soha nem hozott senkit, tehát valószínűleg el sem indult
//   thanks   — most is hoz, őt nem noszogatni kell, hanem megerősíteni
//
// Behelyettesíthető: {{name}} (keresztnév), {{code}}, {{total}}, {{new30}}.
// A partnereknél NINCS nyelv-mező az adatban, ezért a nyelvet küldéskor kézzel
// kell választani — a listában látod a neveket, és tudsz külön kört küldeni
// a magyaroknak és a külföldieknek.

export const PARTNER_TEMPLATES = {
  restart: {
    label: '🔄 Felélesztés',
    hint: 'Akinek volt már regisztrációja, de elhallgatott',
    hu: {
      subject: 'Hogy megy az AI TourMate ajánlás?',
      bodyText: `Szia {{name}},

az AI TourMate partnerprogramban a te kódod a {{code}}, és eddig {{total}} regisztrációt hozott. Köszönöm!

Az utóbbi időben nem érkezett új regisztráció a kódodra, ezért gondoltam, megkérdezem: van valami, ami akadályoz? Hiányzik anyag, nem működik valami, vagy egyszerűen félrement a naptáradban?

Ha kéred, küldök kész posztokat és képeket, amiket csak meg kell osztanod — nem kell semmit kitalálnod.

Írj vissza akár egy mondattal, hogy mire lenne szükséged.

Üdv,
Bódi Gábor
AI TourMate`,
    },
    en: {
      subject: 'How is the AI TourMate referral going?',
      bodyText: `Hi {{name}},

your AI TourMate partner code is {{code}}, and it has brought in {{total}} sign-ups so far. Thank you for that!

There haven't been new sign-ups on your code recently, so I wanted to ask: is anything getting in the way? Missing materials, something not working, or did it simply slip down the list?

If it helps, I can send you ready-made posts and images — nothing for you to write from scratch.

Even a one-line reply telling me what you'd need would help.

Best,
Gábor Bódi
AI TourMate`,
    },
  },

  start: {
    label: '🚀 Indulás',
    hint: 'Akinek még soha nem volt regisztrációja',
    hu: {
      subject: 'Itt a partnerkódod — segítsek elindulni?',
      bodyText: `Szia {{name}},

a partnerkódod a {{code}}, és még nem érkezett rá regisztráció. Ez teljesen rendben van — a legtöbb esetben csak az első lépés hiányzik.

Ha szeretnéd, küldök egy rövid csomagot: kész szöveget, néhány képet és a linkedet, amit egy az egyben meg tudsz osztani. Nagyjából öt perc, és onnantól működik.

Szólj, ha küldhetem — vagy ha időközben meggondoltad magad, az is teljesen rendben, csak írd meg.

Üdv,
Bódi Gábor
AI TourMate`,
    },
    en: {
      subject: 'Your partner code is ready — want help getting started?',
      bodyText: `Hi {{name}},

your partner code is {{code}}, and it hasn't had any sign-ups yet. That's completely fine — usually it's just the first step that's missing.

If you'd like, I'll send you a short pack: ready-made copy, a few images and your link, all set to share as-is. About five minutes of work and it's running.

Let me know if I should send it — and if you've changed your mind in the meantime, that's fine too, just tell me.

Best,
Gábor Bódi
AI TourMate`,
    },
  },

  thanks: {
    label: '🙏 Köszönet',
    hint: 'Aki most is hoz regisztrációt',
    hu: {
      subject: 'Köszönöm — {{total}} regisztráció a kódodra',
      bodyText: `Szia {{name}},

csak szerettem volna megköszönni: a {{code}} kódodra eddig {{total}} regisztráció érkezett, ebből {{new30}} az elmúlt 30 napban.

Ha bármi kell — új képek, más szövegezés, vagy egy konkrét városra szabott anyag —, szólj, és megcsinálom.

Üdv,
Bódi Gábor
AI TourMate`,
    },
    en: {
      subject: 'Thank you — {{total}} sign-ups on your code',
      bodyText: `Hi {{name}},

just a quick thank you: your code {{code}} has brought in {{total}} sign-ups so far, {{new30}} of them in the last 30 days.

If you need anything — new images, different copy, or material tailored to a specific city — let me know and I'll put it together.

Best,
Gábor Bódi
AI TourMate`,
    },
  },
};

// Melyik sablont ajánljuk egy partnerhez? A felhasználó felülbírálhatja.
export function suggestTemplate(p) {
  if (!p.total) return 'start';
  if (p.new30 > 0) return 'thanks';
  return 'restart';
}
